import { RootReducerState } from "../rootReducer";

export const selectCurrentMenuItem = () => (x: RootReducerState) => {
  return x.menuItem.menuItemName;
};
